<div class="emp-page">

    <!-- ── Page header ───────────────────────────────── -->
    <div class="emp-header">
        <div class="emp-header-left">
            <h2 class="emp-title">Employee</h2>
            <span class="emp-count">{{ totalRecords() }} accounts</span>
        </div>
        <div class="emp-header-actions">
            @if (activeTab === 1) {
            <button class="emp-btn" type="button" (click)="activityLogList?.exportActivity()" [disabled]="activityLogList?.exporting()">
                @if (activityLogList?.exporting()) {
                    <i class="fa-solid fa-spinner fa-spin"></i> Exporting…
                } @else {
                    <i class="fa-solid fa-arrow-up-from-bracket"></i> Export
                }
            </button>
            }
            @if (employee()?.role === 'SUPER_ADMIN') {
            <button class="emp-btn emp-btn--primary" type="button" (click)="openAddEmployeeDialog()">
                <i class="fa-solid fa-plus"></i> Add employee
            </button>
            }
        </div>
    </div>

    <!-- ── Tabs ──────────────────────────────────────── -->
    <div class="emp-tabs">
        <button class="emp-tab" [class.emp-tab--active]="activeTab === 0" (click)="activeTab = 0" type="button">
            Employees
        </button>
        <button class="emp-tab" [class.emp-tab--active]="activeTab === 1" (click)="activeTab = 1" type="button">
            Employee activity log
        </button>
    </div>

    <!-- ── Tab content ───────────────────────────────── -->
    <div class="emp-card">
        <div [hidden]="activeTab !== 0">
            <app-table-component
                [data]="employeesList()"
                [columns]="tableColumns"
                [totalRecords]="totalRecords()"
                [rows]="rows"
                [first]="first"
                (pageChange)="onPageChange($event)"
                [showColumnSelector]="false"
                [showClearFilters]="false"
                [searchControl]="searchControl"
                [customFilters]="[roleFilter, statusFilter, createdDateFilter]" />
        </div>
        <div [hidden]="activeTab !== 1">
            <app-employee-activity-log-list />
        </div>
    </div>

</div>

@defer (when addEmployeeDialog; prefetch on idle) {
<app-add-employee-form (addedEmployee)="onEmployeeAdded()" [(visibility)]="addEmployeeDialog" />
}

@defer (when updateEmployeeDialog; prefetch on idle) {
<app-update-employee-form (updatedEmployee)="onEmployeeUpdated()" [selectedEmployee]="selectedEmployee" [(visibility)]="updateEmployeeDialog" />
}

@defer (when deleteEmployeeDialog; prefetch on idle) {
<app-delete-employee-form (deletedEmployee)="onEmployeeDeleted()" [selectedEmployee]="selectedEmployee" [(visibility)]="deleteEmployeeDialog" />
}
